import * as service from './checklist.services.js'

export default {
  data() {
    return {
      removeitems: true,
      isprintablearea: true,
      checklist_Data: [],
      checklistid: '',
      checkId: '',
      wordmeaning: '',
      selecteditemid: '',
      data: [],
      test: '',
      radio2: '',
      chosen: [],
      ccount: 0,
      nccount: 0,
      pcount: 0,
      nacount: 0,
      totalpercentage: 0,
      helptext: [],
      mahctext: ''

    }
  },

  props: ['data', 'isediting', 'isAddingOrEditing'], //FG - FOOF - After Cert - First Release (7) - First Release Security

  mounted() {

    let context = this
    this.$router.app.$on('check_back', (data) => {
      this.$emit('cancel', true)

    })
    $('body').on('hidden.bs.modal', function () {
      if ($('.modal.in').length > 0) {
        $('body').addClass('modal-open')
      }
    })
    if (this.isediting) {

      var CheckListRunId = this.data.Id
      this.checklistid = this.data.ChecklistId
      this.checkId = CheckListRunId
      this.GetChecklistRunDetails(CheckListRunId)
    } else {

      var CheckListId = this.data.CheckListId

      this.checklistid = CheckListId
      this.getchecklist(CheckListId)
    }

    setTimeout(function () {

      $('.glossaryLookup').click(function () {

        let text = $(this).text()

        var checklistid = context.checklistid
        context.getworddef(text, checklistid)

      })

    }, 1000)
  },

  methods: {
    getchecklist(id) {
      let context = this
      service.Getchecklist_data(id).then(function (response) {

        context.checklist_Data = response
        context.totalpercentage = context.checklist_Data[0].Completion

      }, (error) => {
        this.$notify({

          title: 'Error',

          message: error,

          type: 'error'

        })
      })

    },
    Print() {

    },
    GetChecklistRunDetails(checklistRunId) {
      let context = this
      service.GetChecklistRunDetails(checklistRunId).then(function (response) {

        context.totalpercentage = ''
        context.checklist_Data = response
        context.totalpercentage = context.checklist_Data[0].Completion
        context.selected('', '')

        setTimeout(function () {
          $('.tooltip1').tooltipster({
            contentCloning: true,
            maxWidth: '300',
            contentAsHTML: true
            /*     side: 'left',*/
          }, 200)
        })

      }, (error) => {
        this.$notify({

          title: 'Error',

          message: error,

          type: 'error'

        })
      })
    },
    backProfile() {

      this.$emit('cancel', true)
      tooltip.startTooltip(50)
    },
    openhelp(data) {

      let context = this
      var checklistItemId = data.Id
      service.GetChecklistItemHelps(checklistItemId).then(function (response) {

        response = response ? response : []

        // context.helptext = response

        // context.helptext = "<h1>sd</h1>"
        let helptxt = ''
        if (response.length > 0) {

          context.helptext = ''

          let cou = 0
          let p = ''
          let weight = 0
          let k = 0
          for (let i = 0; i < response.length; i++) {

            if (response[i].TextType == 0) {
              weight = 700
            } else {
              weight = 0
            }

            /* k = response[i].Code.split('.').length - 1

             cou = k * 20*/

            k = response[i].Ordinance

            cou = k * 20

            helptxt += '<div style=\'padding-left:' + cou + 'px;font-weight:' + weight + '\'>' + response[i].Description + '</div>'

            //helptxt += response[i].Description
            let old_k = k
          }
          context.showdesc1(helptxt)
        } else {

          helptxt = '<div><span style="font-weight:700;padding:20px">No Help Available</span></div>'
          context.showdesc1(helptxt)
        }

        $('#HelpModel').modal('show')
        setTimeout(function () {

          $('.glossaryLookup').click(function () {

            let text = $(this).text()

            var checklistid = context.checklistid
            context.getworddef(text, checklistid)

          })
          $('.codeTextLookup').click(function () {

            let text = $(this).text()

            var checklistid = context.checklistid

            text = text.replace('MAHC', '').trim()
            context.GetChecklistItemHelpsByCode(text, checklistid)

          })

        }, 1000)
      }, (error) => {
        this.$notify({

          title: 'Error',

          message: error,

          type: 'error'

        })
      })
    },

    selected(item, key) {

      this.ccount = 0
      this.nccount = 0
      this.pcount = 0
      this.nacount = 0

      var num = 0

      for (var i = 0; i < this.checklist_Data.length; i++) {

        for (var z = 0; z < this.checklist_Data[i].ChecklistItems.length; z++) {
          if (this.checklist_Data[i].ChecklistItems[z].SelectedStatus == 'C') {

            this.ccount = this.ccount + 1

          }
          if (this.checklist_Data[i].ChecklistItems[z].SelectedStatus == 'NC') {

            this.nccount = this.nccount + 1
          }
          if (this.checklist_Data[i].ChecklistItems[z].SelectedStatus == 'P') {

            this.pcount = this.pcount + 1
          }
          if (this.checklist_Data[i].ChecklistItems[z].SelectedStatus == 'NA') {

            this.nacount = this.nacount + 1
          }

        }
        num = num + this.checklist_Data[i].ChecklistItems.length
      }

      if (item == '') {

      } else {
        this.totalpercentage = (this.ccount + this.nccount + this.pcount + this.nacount) / num
        this.totalpercentage = Math.round(this.totalpercentage * 100, 2)
      }

    },

    print_pdf() {

      loader.startLoader()
      service.GetPdf(this.checkId).then(function () {
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    save() {

      let model = {
        PoolId: this.data.PoolID,
        ChecklistId: this.data.CheckListId,
        Completion: this.totalpercentage,
        ChecklistItems: []

      }

      for (var i = 0; i < this.checklist_Data.length; i++) {
        for (var z = 0; z < this.checklist_Data[i].ChecklistItems.length; z++) {

          model.ChecklistItems.push({
            ChecklistItemId: this.checklist_Data[i].ChecklistItems[z].Id,
            SelectedStatus: this.checklist_Data[i].ChecklistItems[z].SelectedStatus,
          })

        }
      }

      let context = this
      loader.startLoader()
      service.AddChecklistRun(model).then(function (response) {

        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{}))
          return;

        context.$notify({
          title: 'Success',
          message: 'Checklist submitted',
          type: 'success'
        })
        loader.stopLoader()
        context.$emit('cancel', true)

      }, (error) => {
        loader.stopLoader()
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
        this.$notify({

          title: 'Error',

          message: error,

          type: 'error'

        })
      })

    },
    update() {
      let model = {
        Id: this.data.Id,
        PoolId: this.data.PoolId,
        ChecklistId: this.data.ChecklistId,
        Completion: this.totalpercentage,
        ChecklistItems: []

      }

      for (var i = 0; i < this.checklist_Data.length; i++) {
        for (var z = 0; z < this.checklist_Data[i].ChecklistItems.length; z++) {

          model.ChecklistItems.push({
            ChecklistItemId: this.checklist_Data[i].ChecklistItems[z].Id,
            SelectedStatus: this.checklist_Data[i].ChecklistItems[z].SelectedStatus,
          })

        }
      }

      let context = this
      loader.startLoader()
      service.UpdateChecklistRun(model).then(function (response) {
        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{}))
          return;

        context.$notify({
          title: 'Success',
          message: 'Updated Successfully',
          type: 'success'
        })
        loader.stopLoader()
        context.$emit('cancel', true)

      }, (error) => {
        loader.stopLoader()
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    cancel() {
      this.$emit('cancel', true)
    },

    replaceTextBetweenBars1(x, y) {

      return '<span style=\'cursor:pointer\' class=\'glossaryLookup\'>' + x + '</span>'

    },
    replaceTextBetweenCarets1(x) {
      return '<span class=\'codeTextLookup\'>' + x + '</span>'
    },
    showdesc1(desc) {
      var regexpBars = /\|(.*?)\|/g //Find strings between bars and replace it (note: g at end means globally.. so every one is replaced)
      var regexpCarets = /\^(.*?)\^/g //Find strings between carets

      var result = desc.replace(regexpBars, this.replaceTextBetweenBars1('$1', desc.Id))
        .replace(regexpCarets, this.replaceTextBetweenCarets1('$1'))

      this.helptext = result

    },

    replaceTextBetweenBars(x, y) {

      return '<span style=\'cursor:pointer\' class=\'glossaryLookup\'>' + x + '</span>'

    },
    replaceTextBetweenCarets(x) {
      return '<span class=\'codeTextLookup\'>' + x + '</span>'
    },
    showdesc(desc) {
      var regexpBars = /\|(.*?)\|/g //Find strings between bars and replace it (note: g at end means globally.. so every one is replaced)
      var regexpCarets = /\^(.*?)\^/g //Find strings between carets
      var str = desc.Name

      var result = str.replace(regexpBars, this.replaceTextBetweenBars('$1', desc.Id))
        .replace(regexpCarets, this.replaceTextBetweenCarets('$1'))

      return result
    },

    getworddef(text, id) {

      let context = this
      let model = {
        ChecklistId: id,
        AlternateWord: text
      }
      service.GetChecklistGlossary(model).then(function (response) {

        $('#wordmeaningModel').modal('show')
        context.wordmeaning = response

      }, (error) => {
        this.$notify({

          title: 'Error',

          message: error,

          type: 'error'

        })
      })

    },

    GetChecklistItemHelpsByCode(text, id) {

      let context = this

      service.GetChecklistItemHelpsByCode(text, id).then(function (response) {
        context.mahctext = ''
        let cou = 0
        let p = ''
        let weight = 0
        let k = 0
        for (let i = 0; i < response.length; i++) {

          if (response[i].TextType == 0) {
            weight = 700
          } else {
            weight = 0
          }

          k = response[i].Code.split('.').length - 1

          cou = k * 20

          context.mahctext += '<div style=\'padding-left:' + cou + 'px;font-weight:' + weight + '\'>' + response[i].Description + '</div>'

          //helptxt += response[i].Description

        }

        $('#MahcModel').modal('show')
      }, (error) => {
        this.$notify({

          title: 'Error',

          message: error,

          type: 'error'

        })
      })

    }

  },

}



// WEBPACK FOOTER //
// ./src/components/checklist/checklist.controller.js